import { render, staticRenderFns } from "./AttachedResponsibilitiesToRole.vue?vue&type=template&id=7e1fcbf5&scoped=true"
import script from "./AttachedResponsibilitiesToRole.vue?vue&type=script&lang=js"
export * from "./AttachedResponsibilitiesToRole.vue?vue&type=script&lang=js"
import style0 from "./AttachedResponsibilitiesToRole.vue?vue&type=style&index=0&id=7e1fcbf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1fcbf5",
  null
  
)

export default component.exports